import './SectionForm.less';
import React from 'react';
import CustomForm from "../../../../bootstrap/components/custom-form/CustomForm";
import __ from "../../../i18n";
import DeleteButton from "../delete-button/DeleteButton";


export default function SectionForm({section, questions, setSections, setSectionErrors, setQuestions, setPieces, setSelectedNodeHash}) {

    return <div className="section-form">
        <CustomForm
            fieldsConfig={{
                description: {
                    type: 'richText',
                    name: __('Description'),
                    rules: {
                        required: true
                    }
                }
            }}
            layoutConfig={['description']}
            onInitialized={(values, errors) => {
                setSections(sections => {
                    return sections.map(sec => {
                        if (sec.id === section.id) {
                            Object.assign(sec, values);
                        }
                        return sec;
                    });
                });
                setSectionErrors(prevErrors => {
                    const _errors = {...prevErrors};
                    if (Object.keys(errors).length > 0) {
                        _errors[section.id] = errors;
                    } else {
                        delete _errors[section.id];
                    }
                    return _errors;
                });
            }}
            onChange={(values, errors) => {
                setSections(sections => {
                    return sections.map(sec => {
                        if (sec.id === section.id) {
                            Object.assign(sec, values);
                        }
                        return sec;
                    });
                });
                setSectionErrors(prevErrors => {
                    const _errors = {...prevErrors};
                    if (Object.keys(errors).length > 0) {
                        _errors[section.id] = errors;
                    } else {
                        delete _errors[section.id];
                    }
                    return _errors;
                });
            }}
            defaultValues={section}
        />
        <DeleteButton
            title={__('Delete this section')}
            handleDelete={() => {
                const sectionQuestionIds = questions.filter(q => q.group_id === section.id).map(q => q.id);
                setPieces(pieces => pieces.filter(p => !sectionQuestionIds.includes(p.question_id)));
                setQuestions(questions => questions.filter(q => q.group_id !== section.id));
                setSections(sections => sections.filter(s => s.id !== section.id));
                setSelectedNodeHash('');
            }}
        />
    </div>;
}
